/**
 * Untitled UI `size` token shared by every auth-form input and submit button
 * (login, register, forgot-password). Bound to the extended "2xl" variant
 * (56px height, 16px padding, 16px text) added to both Input and Button.
 */
export const AUTH_FORM_SIZE = '2xl' as const;
